import { call, put } from 'redux-saga/effects';
import {
  awaitingApprovalFailure,
  awaitingApprovalSuccess,
  changeStatusAfterUpdate,
  fetchActivityLogsRequest,
} from '../actions';
import { ApiError, ApiResponse } from 'store/api/types';
import { AwaitingApprovalRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import { awaitingApproval } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { DataLogStatus, SubmissionUpdateField } from 'store/app/enums';
import { updateSubmissionLog } from 'store/organisation/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { sendTifdForApprovalFromReturnSaga } from 'store/tifd/sagas/sendTifdForApprovalSaga';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* awaitingApprovalSaga(action: AwaitingApprovalRequestAction) {
  const sentTifd: boolean = yield call(
    sendTifdForApprovalFromReturnSaga,
    action
  );
  if (sentTifd) return;

  try {
    let err: ApiError | null;
    const { dataLogId, reportUrl, mappingId } = action.payload;

    const response: ApiResponse = yield call(
      awaitingApproval,
      dataLogId,
      reportUrl,
      mappingId
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('common.success-exclamation'),
      description: response.responseMessage.message,
      type: MessageStates.SUCCESS,
    };

    yield put(turnMessageOn(message));
    yield put(fetchActivityLogsRequest(dataLogId));
    yield put(changeStatusAfterUpdate(DataLogStatus.AWAITING_APPROVAL));
    yield put(
      updateSubmissionLog(
        mappingId,
        SubmissionUpdateField.STATUS,
        'AWAITING_APPROVAL',
        dataLogId
      )
    );
    yield put(awaitingApprovalSuccess());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(awaitingApprovalFailure());
  }
}
